export default "__VITE_ASSET__4c8a3e7a__"